export default "__VITE_ASSET__7573132c__"